import api from "./apis/api";
import { logger } from "../utils/utils";
import storage from "../utils/storage";
import { USER_MANAGEMENT } from "../containers/Routes/routes";
import { get } from "lodash";

class UserService {
  createUser(userReq) {
    logger("UserService", "createUser");
    return api.user.createUser(userReq);
  }

  getUser() {
    logger("UserService", "getUser");
    return api.user.getUser();
  }

  getQuicksightEmbedUrl() {
    logger("UserService", "getQuicksightEmbedUrl");
    return api.user.getQuicksightEmbedUrl();
  }

  updateUser(userReq) {
    logger("UserService", "updateUser");
    return api.user
      .updateUser(userReq?.userId, userReq?.payload)
      .then(async (userData) => {
        if (
          userReq?.pathname === USER_MANAGEMENT.USER_DETAILS_EDIT ||
          userReq?.userId === get(userData, "id", -1)
        ) {
          await Promise.all([storage.set("user", JSON.stringify(userData))]);
        }
        return userData;
      })
      .catch((e) => {
        throw e;
      });
  }

  changePassword(userReq) {
    logger("UserService", "changePassword");
    return api.user.changePassword(userReq);
  }

  getUserList(userReq) {
    logger("UserService", "getUserList");
    return api.user.getUserList(userReq);
  }

  uploadPhoto(userReq) {
    logger("UserService", "uploadPhoto");
    return api.user.uploadPhoto(userReq);
  }
}

export default new UserService();
